<template>
	<transition name="fade">
		<div id="container">
			<div class="bar"></div>
			<div class="header-wrapper">
				<div class="box-header">
					<router-link class="box-home" to="/">
						<h2><span class="icon"><i class="fas fa-home"></i></span>Home</h2>
					</router-link>
					<router-link class="box-title-home" v-for="obj in aObjetos" :key="obj.title" :to="{ path: `${obj.pathName}` }">
						<span><i class="arrow fas fa-angle-right"></i></span>
						<div class="box-title" >
							<h2><span>{{ obj.title }}</span></h2>
						</div>
					</router-link>
				</div>
				<div class="right">
					<router-link v-if="textButton" :to="pathName" class="btn-add">
						<i v-if="pathIcone" class="fas fa-arrow-left"></i> {{ textButton }}
					</router-link>
				</div>
			</div>
			<div class="content">
				<slot></slot>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Container',
	props: {
		title: String,
		pathName: {
			default: ''
		},
		route: String,
		textButton: String,
		pathIcone: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			aObjetos: [{ title: '', pathName: '' }]
		}
	},
	async created () {
		if (this.$route.meta.breadCrumb) {
			const path = this.$route.path.split('/')[1]
			const aBreadCrumb = this.$route.meta.breadCrumb.split('|')

			this.aObjetos = Object.keys(aBreadCrumb).map((i, index) => {
				let obj
				index === 0
					? obj = { title: aBreadCrumb[i], pathName: `/${path}` }
					: obj = { title: aBreadCrumb[i], pathName: '' }
				return obj
			})
		}
	}
}
</script>

<style lang="scss" scoped>
#container {
	margin-top:100px;
	background-color: #FFFFFF;
	border-radius:10px;
	padding:24px 20px 34px 26px;
	position: relative;

	.bar {
		width: 400px;
		height: 8px;
		position:absolute;
		top: 0;
		background-color: $success-color;
	}

	.header-wrapper {
		display:flex;
		justify-content: space-between;
		align-items: center;

		.box-header {
			display: flex;
			align-items: center;

			i {
					font-size: 20px;
					color:$success-color-light;

					.arrow {
						margin: 0 10px 0 5px;
						font-size: 20px;
					}
			}

			.box-home {
				&:hover h2{
					color: $success-color;
					.icon {
						background-color: $success-color;
					}
				}

				h2 {
					font-family: $font-family;
					font-size: 1.5em;
					font-weight: 300;
					color: $success-color-light;

					.icon {
						background-color: $success-color-light;
						border-radius: 5px;
						display: inline-flex;
						align-items: center;
						padding: 5px;
						margin-right: 5px;
						width: 35px;
						height: 35px;

						i {
							font-size: 23px;
							color:#fff;
						}

					}

				}
			}

			a:link {
				text-decoration:none;
			}

			.box-title-home{
				display: flex;
				align-items: center;
				cursor: pointer;

				&:hover {
					.box-title{
							h2 span{
							color: $success-color;
							cursor: pointer;
						}
					}
				}

				span{
					.arrow {
						margin: 5px 10px 0 10px;
						color: $success-color-light;
					}
				}

				.box-title {
					background-color: $inputs-color;
					padding: 10px;
					border-radius:5px;
					display: flex;
					align-items: center;
					max-height: 35px;

					h2 {
						font-family: $font-family;
						font-size: 1.5em;
						font-weight: 300;
						span{
							color: $success-color-light;
						}
					}
				}
			}

			.box-title-home:last-child{
				h2 span{
					color: $success-color;
				}
				span{
					.arrow {
						color: $success-color;
					}
				}
			}

		}

		.right {
			display: inline-flex;
			align-items: center;
			gap: 20px;
			.btn-add {
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: $success-color;
				border-radius:5px;
				text-decoration: none;
				color:#fff;
				text-transform: uppercase;
				font-family: $font-family;
				font-size: 1em;
				font-weight: $font-weight-buttons;
				padding: 16px 49px 15px 47px;

				&:hover, &:active{
					background-color: $main-color;
					color: #f9fdff;
				}

				i{
					margin-right:10px;
				}
			}

		}

	}
	.content {
		margin-top: 30px;
	}
}
</style>

// Medias Querys
<style lang="scss" scoped>
	@media (max-width: 1090px) {
		#container{
			.header-wrapper {
				.box-header {
					.box-home {
						font-size: $font-size-1024;
						padding: 10px 15px 10px 15px;
					}
					.box-title {
						padding: 10px;
						height: 40px;
						h2 {
							font-size: $font-size-1024;
						}
					}
				}
				.right {
					.btn-add {
						padding: 16px 19px 15px 18px;
					}
				}
			}
		}
	}
</style>
